module.exports = __webpack_public_path__ + "static/media/Lights.9b7b4879.logo";